var _process$env;

import * as ReactDOM from 'react-dom';
import App from 'moduleBase/containers/App';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import * as React from 'react';
import * as Sentry from '@sentry/react';
import { configureStore, history } from '@collaborator/npm_modules/dist/components/redux';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'moduleBase/components/ErrorFallback';
import 'src/css/style.scss';
import Notifier from 'components/notifier/containers/Notifier';
import { FEATURES } from 'src/constants';
import { sentryInit } from 'modules/sentry/init';
import { FeatureFlagProvider } from '@collaborator/npm_modules/dist/components/featureToggle';
import { SweetAlert } from '@collaborator/npm_modules/dist/components/sweetAlert';
import TYPES from 'di/types';
import container from 'di/inversify.config';
import app from 'srcJs/App';
var sentryEnhancer = null;

if (((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.SENTRY_ENABLED) === '1') {
  sentryInit(process.env.SENTRY_DSN, parseFloat(process.env.SENTRY_SAMPLE_RATE), parseInt(process.env.SENTRY_NORMALIZE_DEPTH, 10));
  sentryEnhancer = Sentry.createReduxEnhancer();
}

var networkService = container.get(TYPES.NetworkService);
var store = configureStore({
  networkService: networkService,
  app: app
}, sentryEnhancer);
ReactDOM.render( /*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(ConnectedRouter, {
  history: history
}, /*#__PURE__*/React.createElement(FeatureFlagProvider, {
  features: FEATURES
}, /*#__PURE__*/React.createElement(SweetAlert, null), /*#__PURE__*/React.createElement(Notifier, null), /*#__PURE__*/React.createElement(ErrorBoundary, {
  FallbackComponent: ErrorFallback
}, /*#__PURE__*/React.createElement(App, null))))), document.getElementById('app'));